<template>
  <div class="change-phone" v-wechat-title="$route.meta.title">
    <header v-if="!isAPP">
      <div class="left" @click="goBack">
        <img src="../../../image/arrows.png" />
      </div>
      <div class="text">更换手机号码</div>
    </header>
    <div class="content">
      <div class="picture">
        <img src="../../../image/phone.png" alt />
      </div>
      <div class="character">
        <div class="top">你的当前手机号码为{{ hideNum }} ，更换时需要验证旧</div>
        <div class="botton">手机，若旧手机已注销，请联系客服更换手机号码</div>
      </div>
      <div class="btn">
        <button @click="affirm">更换手机号</button>
      </div>
    </div>
    <div class="home" v-show="isPopUp">
      <div class="pop-up">
        <div class="change">手机号更换提示</div>
        <div class="text">
          以下产品为统一账户，若你使用当前手机号码
          <span>{{ hideNum }}</span
          >注册过以下产品,更换手机号码后，需要使用新的手机号码才能登陆；
        </div>
        <div class="hyx">— 华宇讯旗下产品 —</div>
        <div class="product">
          <div class="sdyx">
            <img src="../../../image/sdyx.png" alt />
            <span>苏打优选</span>
          </div>
          <div class="mzdy">
            <img src="../../../image/mzdy.png" alt />
            <span>卖座电影</span>
          </div>
        </div>
        <div class="btn">
          <div class="cancel" @click="cancel">取消</div>
          <span></span>
          <div class="affirm" @click="affirm">确认更换</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CONSTANT from '../../../constant'
import userService from '../../../service/user'
import { Toast } from 'mint-ui'
import { app } from '../../../util/platform'
import setDocumentTitle from '@util/document-title'
import userManager from '@util/userManager'

const CAN_CHANGE_PHONE = 0
const UNABLE_CHANGE_PHONE = 6801032

export default {
  data() {
    return {
      phoneNum: userManager.getMobile(),
      isPopUp: false, //是否显示弹框
      // className1: "content",
      // className2: app.isMZMall() ? "" : "contentTop"
    }
  },
  computed: {
    isAPP() {
      return app.isMZMall()
    },
    hideNum() {
      let hideNum = this.phoneNum.substr(0, 3) + '****' + this.phoneNum.substr(7)
      return hideNum
    },
  },
  mounted() {
    setDocumentTitle('更换手机号码')
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    verify() {
      this.isPopUp = true
    },
    affirm() {
      userService
        .mobileChangeCheck()
        .then((data) => {
          if (data.status === CAN_CHANGE_PHONE) {
            this.$router.push('/login/user/verify')
          } else if (data.status === UNABLE_CHANGE_PHONE) {
            this.$router.push('/login/user/phone_abnormal')
          } else {
            Toast({
              message: data.msg,
              position: 'bottom',
              duration: 2000,
            })
          }
        })
        .catch((err) => {})
    },
    cancel() {
      this.isPopUp = false
    },
  },
}
</script>

<style lang="less">
.change-phone {
  width: 100%;
  height: 100vh;
  position: relative;
  header {
    width: 100%;
    height: 44px;
    position: relative;
    background-color: #fff;

    .left {
      width: 44px;
      height: 44px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        display: block;
        width: 11px;
        height: 19px;
      }
    }
    .text {
      width: 103px;
      height: 24px;
      position: absolute;
      top: 10px;
      left: 136px;
      text-align: center;
      line-height: 24px;
      font-size: 17px;
      color: rgb(25, 26, 27);
    }
  }
  // .contentTop {
  //   margin-top: 68px;
  // }
  .content {
    padding-top: 69px;
    background-color: #fbfbfb;
    height: 100%;
    .picture {
      width: 100%;
      height: 132px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 72px;
        height: 132px;
      }
    }
    .character {
      width: 100%;
      margin-top: 50px;
      .top {
        font-size: 13px;
        text-align: center;
        color: rgb(121, 125, 130);
        line-height: 19.5px;
      }
      .botton {
        font-size: 13px;
        text-align: center;
        color: rgb(121, 125, 130);
        line-height: 19.5px;
      }
    }
    .btn {
      width: 100%;
      height: 44px;
      display: flex;
      justify-content: center;
      margin-top: 25px;
      button {
        width: 300px;
        height: 100%;
        border-radius: 4px;
        background-color: rgb(192, 49, 49);
        color: #fff;
        font-size: 15px;
        border: 1px solid transparent; //自定义边框
        outline: none; //消除默认点击蓝色边框效果
      }
    }
  }
  .home {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background-image: url(../../../image/background.png);
    .pop-up {
      width: 280px;
      height: 306px;
      position: absolute;
      left: 50%;
      margin-left: -140px;
      top: 50%;
      margin-top: -153px;
      border-radius: 3px;
      background-color: rgb(255, 255, 255);
      .change {
        font-size: 17px;
        color: rgb(25, 26, 27);
        text-align: center;
        margin-top: 26px;
      }
      .text {
        width: 234px;
        height: 54px;
        margin-left: 23px;
        margin-top: 23px;
        font-size: 12px;
        color: rgb(25, 26, 27);
        span {
          color: rgb(192, 49, 49);
        }
      }
      .hyx {
        width: 100%;
        text-align: center;
        margin-top: 15px;
        color: rgb(121, 125, 130);
      }
      .product {
        height: 70px;
        margin-top: 10px;
        display: flex;
        justify-content: center;
        .sdyx {
          width: 50px;
          height: 70px;
          margin-right: 22px;
          img {
            width: 50px;
            height: 50px;
          }
          span {
            display: block;
            width: 100%;
            text-align: center;
            font-size: 11px;
            color: rgb(121, 125, 130);
          }
        }
        .mzdy {
          width: 50px;
          height: 70px;
          margin-left: 22px;
          img {
            width: 50px;
            height: 50px;
          }
          span {
            display: block;
            width: 100%;
            text-align: center;
            font-size: 11px;
            color: rgb(121, 125, 130);
          }
        }
      }
      .btn {
        width: 100%;
        height: 50px;
        margin-top: 15px;
        display: flex;
        border-top: 0.5px solid rgb(237, 237, 237);
        .cancel {
          flex: 1;
          text-align: center;
          line-height: 50px;
          font-size: 15px;
          color: rgb(25, 26, 27);
        }
        span {
          display: block;
          width: 1px;
          height: 50px;
          background-color: rgb(237, 237, 237);
        }
        .affirm {
          flex: 1;
          text-align: center;
          line-height: 50px;
          font-size: 15px;
          color: rgb(192, 49, 49);
        }
      }
    }
  }
}
</style>
